module.exports = __webpack_public_path__ + "back-customers.jpg?8993eacb0a6db5d3b49539255d870bf6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resources/img/back-customers.jpg
// module id = 7
// module chunks = 0